var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivityOnboardingCat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 248,
    viewBox: "0 0 141 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_109)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4103 237.968C83.4103 237.968 86.1801 240.956 82.5594 242.876C78.9303 244.795 74.4502 246.081 74.4502 246.081L89.5923 245.864L87.6735 237.116L83.4103 237.968Z",
    fill: "#2A285F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.142 239.887C111.142 239.887 113.912 242.875 110.291 244.794C106.662 246.714 102.182 248 102.182 248L117.324 247.783L115.405 239.035L111.142 239.887Z",
    fill: "#2D307A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0871 121.346L68.1682 129.985C68.1682 129.985 66.7833 166.051 72.3313 193.796C77.8792 221.541 82.1424 240.321 82.1424 240.321L90.2515 239.47C90.2515 239.47 83.4271 141.303 94.5147 124.234L70.0954 121.354L70.0871 121.346Z",
    fill: "#E88418"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0116 118.249C76.5861 120.811 81.7003 171.176 91.5197 198.912C101.331 226.657 111.142 242.449 111.142 242.449L117.966 241.598C117.966 241.598 101.756 149.833 104.318 125.502L77.0116 118.249Z",
    fill: "#F49523"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8428 48.9958C66.8833 49.3129 43.8489 24.9904 43.8489 24.9904C43.8489 24.9904 41.9301 23.3878 41.6131 20.191C41.2961 16.9858 42.5725 12.8291 40.3366 13.789C38.1008 14.7489 38.4178 19.8738 38.4178 19.8738C38.4178 19.8738 33.6207 18.5967 32.3359 20.191C31.0595 21.7936 31.0595 26.9101 33.2953 28.8299C35.5312 30.7497 36.816 31.0668 36.816 31.0668C36.816 31.0668 55.0533 64.6794 60.8098 67.559C66.5663 70.4387 73.2906 59.2373 73.2906 59.2373L67.8511 48.9958H67.8428Z",
    fill: "#F6B7BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.798 78.7688C108.798 78.7688 113.278 75.8891 105.277 67.8846C97.2762 59.88 71.6806 49.3213 71.6806 49.3213L61.1187 70.7642C61.1187 70.7642 90.5519 94.7696 97.9103 95.7295C105.269 96.6894 108.789 78.7604 108.789 78.7604L108.798 78.7688Z",
    fill: "#222147"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2823 48.0358C72.3229 48.0358 67.5258 44.1963 67.5258 44.1963C67.5258 44.1963 55.3704 66.2819 56.3298 66.6074C57.2892 66.9246 61.4523 72.3667 61.4523 72.3667L73.2907 48.0358H73.2823Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.359 34.5978C119.201 34.1137 121.278 28.6799 127.677 29.6398C134.076 30.5997 143.036 34.9233 139.833 45.9661C136.629 57.0089 127.994 60.6899 127.994 60.6899L124.315 59.73L121.278 45.8075L119.359 34.6061V34.5978Z",
    fill: "#2D307A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.079 53.1607C113.762 53.6448 106.72 62.6009 106.72 62.6009L122.722 73.9609L127.519 55.5562L114.079 53.1523V53.1607Z",
    fill: "#F6B7BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6008 60.8397C89.6008 60.8397 78.7218 67.5588 73.9247 71.4067C69.1276 75.2462 68.1682 129.985 68.1682 129.985L104.96 127.105C104.96 127.105 103.041 122.305 104.317 116.221C105.594 110.136 121.912 79.0858 122.713 73.9692C123.514 68.8442 106.712 62.6092 106.712 62.6092C106.712 62.6092 99.512 57.0085 89.5924 60.848L89.6008 60.8397Z",
    fill: "#2A285F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.971 18.0542C77.971 18.0542 81.4916 13.1463 77.0115 8.77254C77.0115 8.77254 78.6134 6.31858 77.3286 4.93301C76.0521 3.54744 73.274 6.31858 73.274 6.31858L70.9297 6.10156C70.9297 6.10156 68.9024 -1.04329 67.5175 0.125258C66.1326 1.30216 65.9157 5.35035 65.9157 5.35035C65.9157 5.35035 60.2593 3.0049 51.9415 6.20173C51.9415 6.20173 38.3929 3.21357 31.143 19.2227C31.143 19.2227 17.7028 43.3366 28.5818 67.4505C28.5818 67.4505 26.2375 89.4276 1.27589 84.5197C1.27589 84.5197 -0.642946 84.3027 1.4928 88.1506C3.62855 91.9901 7.24931 91.5644 7.24931 91.5644C7.24931 91.5644 5.97287 91.9901 8.10028 93.7012C10.236 95.4123 18.9792 92.4241 18.9792 92.4241C18.9792 92.4241 18.7623 94.3439 20.6895 94.3439C22.6167 94.3439 29.8582 86.6648 29.8582 86.6648C29.8582 86.6648 29.2158 89.0103 31.5685 88.3759C33.9128 87.7332 34.3383 83.8937 34.3383 83.8937C34.3383 83.8937 34.5552 86.8819 36.0485 84.5364C37.5419 82.191 38.6098 71.9494 34.9807 68.7443C34.9807 68.7443 39.2438 68.1016 40.3117 70.0213C41.3796 71.9411 39.2438 72.7925 41.8051 74.2865C44.3663 75.7806 49.4804 75.7806 51.6162 78.1261C53.7519 80.4715 56.3048 83.6767 56.7386 80.2628C57.1641 76.849 52.05 72.7925 52.05 72.7925C52.05 72.7925 59.0913 62.5509 57.8065 57.643C56.5301 52.7351 51.8331 49.964 51.8331 49.964C51.8331 49.964 53.9688 36.943 55.8877 35.4489C57.8065 33.9548 63.9968 34.1718 65.0564 35.4489C66.1242 36.726 65.6988 40.1398 68.6855 39.9311C71.6722 39.7141 69.5364 30.541 69.5364 30.541L64.6309 27.9785L65.0564 24.7733C65.0564 24.7733 70.6043 26.0504 73.591 25.199C76.5777 24.3477 77.2201 22.4279 77.2201 22.4279C77.2201 22.4279 80.1317 20.5499 77.9626 18.0542H77.971Z",
    fill: "#A7A9AB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3237 51.2409C79.3643 51.5581 56.3299 27.2355 56.3299 27.2355C56.3299 27.2355 54.4111 25.6329 54.094 22.4361C53.777 19.2309 55.0535 15.0742 52.8176 16.0341C50.5817 16.994 50.8988 22.1189 50.8988 22.1189C50.8988 22.1189 46.1017 20.8418 44.8169 22.4361C43.5404 24.0387 43.5404 29.1553 45.7763 31.075C48.0122 32.9948 49.2969 33.312 49.2969 33.312C49.2969 33.312 67.5342 66.9245 73.2907 69.8041C79.0473 72.6838 85.7715 61.4824 85.7715 61.4824L80.332 51.2409H80.3237Z",
    fill: "#FAD3D5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.317 116.22C105.594 110.136 121.912 79.0855 122.713 73.9689C123.514 68.844 106.712 62.6089 106.712 62.6089C106.712 62.6089 105.018 61.3068 102.165 60.3887C105.652 68.0677 98.4774 86.7812 94.9317 93.2917C91.0941 100.336 87.4649 97.1313 87.4649 97.1313C87.4649 97.1313 94.9317 105.67 91.5195 115.06C89.6257 120.269 81.8419 125.661 75.2678 129.442L104.951 127.121C104.951 127.121 103.033 122.322 104.309 116.237L104.317 116.22Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.515 45.6402C131.198 42.7606 133.751 43.4033 136.47 41.158C139.19 38.921 135.67 36.8343 128.47 32.1935C126.042 30.6243 124.056 30.2738 122.48 30.4824C120.102 31.868 119.243 34.2802 119.351 34.5891L121.27 45.7905L124.307 59.7129L127.986 60.6728C127.986 60.6728 134.86 57.7264 138.615 49.2377C135.711 50.2143 131.765 48.0024 131.506 45.6319L131.515 45.6402Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4026 20.7497C76.4026 20.7497 78.0795 19.9484 77.2786 19.6313C76.4777 19.3141 75.2764 19.5478 75.2764 19.5478L76.3943 20.7497H76.4026Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1194 6.26873C69.1277 6.11014 68.6355 1.09372 67.8429 2.0536C67.042 3.01348 66.0325 7.07002 66.3496 7.17853C66.6666 7.28704 67.6844 6.00164 67.7345 6.16857C67.7845 6.32716 69.0109 8.19684 69.1194 6.27708V6.26873Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3269 82.5083C24.9693 84.3196 26.1373 80.4801 26.5627 79.0945C26.9882 77.7089 27.4137 80.5886 28.0561 82.934C28.6985 85.2795 32.3192 79.3032 31.0428 73.7609C30.609 71.8829 29.4577 70.4222 28.248 69.3037C27.689 71.6659 26.2874 75.881 22.9753 79.395C23.4175 80.3215 23.9765 81.5318 24.3269 82.5167V82.5083Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3687 45.9493C24.3436 47.1596 24.3436 48.3949 24.402 49.6553C26.7881 48.8373 29.6496 47.9108 29.341 46.5419C28.9322 44.7557 26.2458 45.6822 24.3687 45.9493Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0989 74.8213C50.857 74.2203 49.2802 75.2052 47.937 76.1818C48.9048 76.4656 49.8225 76.8162 50.5817 77.2836C50.9154 76.4072 51.3409 75.4139 51.0989 74.8213Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3018 74.6121C45.3424 74.3951 46.8357 73.118 46.5187 71.7325C46.3102 70.8143 44.6917 73.2683 43.6238 75.0295C44.5498 75.3216 45.5676 75.5637 46.5938 75.8224C46.7023 75.2298 46.6939 74.7039 46.3018 74.6121Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7202 58.9709C26.2208 61.0742 26.9216 63.1943 27.7558 65.3228C33.5541 62.8939 45.6845 56.0161 46.2935 54.3384C46.9442 52.5772 32.0941 57.8858 25.7202 58.9709Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3023 64.1542C52.809 64.0456 54.7278 65.114 54.7278 65.7567C54.7278 66.3994 51.7411 66.0739 50.2477 66.6081C49.2633 66.9587 52.1749 67.8267 54.611 68.5863C55.2617 67.3927 55.9459 66.0489 56.5215 64.68C55.6705 64.4713 54.8196 64.1959 54.294 64.1542H54.3023Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4514 5.73463C52.8841 7.35391 52.2 10.1084 53.0426 12.4288C54.319 15.9511 57.8647 15.8676 56.3713 13.2551C55.145 11.11 56.071 6.66112 56.8052 4.8916C55.754 5.07523 54.636 5.35902 53.4514 5.73463Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8288 24.8826C62.4033 25.8425 63.7882 27.0194 63.7882 27.0194C63.7882 27.0194 64.222 27.2615 64.7059 27.5119L65.073 24.7825C65.073 24.7825 65.6653 24.916 66.5163 25.0579L66.3494 24.9911C66.3494 24.9911 63.2543 23.9227 62.8288 24.8826Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.017 62.5511C44.0075 64.0619 53.2096 61.8166 57.3976 62.2423C57.9149 60.5312 58.1402 58.9036 57.8148 57.6432C57.723 57.2926 57.5812 56.9671 57.456 56.6416C55.2786 57.0422 52.125 57.6683 51.3074 58.0689C50.031 58.7116 52.6923 58.6031 53.2263 59.1373C53.7602 59.6715 46.2934 60.6314 45.017 62.5511Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5687 45.6404C48.646 45.9576 44.9669 46.7589 44.0074 48.2029C43.4151 49.0876 47.9202 48.9457 52.0332 48.8873C52.2251 47.7855 52.5671 45.9659 52.9926 43.9961C49.1466 44.5386 38.8933 43.921 36.3321 44.9977C33.2953 46.2748 44.4913 45.3149 46.5687 45.6404Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3869 13.2052C76.6444 13.2553 76.6945 14.0566 77.8708 14.4823C78.4465 14.6909 78.8803 14.8996 79.1723 15.0582C79.239 14.6742 79.2807 14.2652 79.2807 13.8396C78.7385 13.681 77.8958 13.1635 77.3869 13.1969V13.2052Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6945 6.16037C76.5861 7.22876 74.7757 7.07017 74.6172 7.22876C74.4587 7.38735 77.0199 8.77292 77.0199 8.77292C77.0199 8.77292 78.6217 6.31896 77.3369 4.93339C76.9615 4.5244 76.4526 4.49936 75.927 4.63291C76.3525 5.0586 76.7446 5.61783 76.6945 6.16037Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70467 86.6653C3.74525 87.6252 7.2659 86.9825 10.0357 86.8823C12.8055 86.7738 9.07628 87.6252 7.69138 89.0191C6.30648 90.4046 11.5291 90.5132 16.4346 87.2078C19.1293 85.3882 20.606 82.8258 21.4152 80.8643C17.978 83.7439 12.9223 85.7638 5.49723 85.1378C5.33872 85.6971 5.09678 86.2813 4.70467 86.6736V86.6653Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2871 25.8425C35.0808 24.9828 32.1942 23.2634 30.1836 21.1934C29.6997 22.2284 29.099 23.6223 28.4399 25.3835C30.1919 25.9427 32.1274 26.4018 33.2871 25.8425Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7158 11.1683C37.9672 14.1564 40.1113 20.0159 43.2065 21.0425C47.3695 22.4281 44.3828 19.44 42.8895 15.9176C41.6297 12.9545 43.7071 8.49732 45.8595 6.32715C43.1147 6.86969 39.811 8.21352 36.7242 11.1599L36.7158 11.1683Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.052 10.6926C76.1938 11.2686 77.9375 11.1183 78.8301 11.4272C78.68 11.0515 78.4881 10.6759 78.2545 10.292C77.4619 10.3755 75.9435 10.2252 76.0603 10.6926H76.052Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8537 34.0801C25.52 35.5658 25.2363 37.1517 24.9944 38.7877C31.5601 39.1633 45.6427 39.3886 47.0443 37.3687C48.3625 35.4656 33.3705 35.2319 25.8453 34.0801H25.8537Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.154 6.26915C63.3792 5.41778 64.0467 5.1006 64.6223 4.98375C63.8381 4.80012 62.6951 4.62483 61.2769 4.56641C60.3008 6.50286 60.843 10.7013 61.719 11.2772C62.6785 11.9199 62.7285 7.86339 63.1623 6.26081L63.154 6.26915Z",
    fill: "#231F20"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0834 9.79058C74.0834 9.79058 69.3614 8.91417 69.2863 10.4333C69.2028 11.9524 72.4065 10.4333 73.5244 10.6753C74.6423 10.9174 74.8843 9.87405 74.0834 9.79893V9.79058Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5088 12.938C74.5088 12.938 69.7868 12.0616 69.7118 13.5807C69.6367 15.0999 72.8319 13.5807 73.9499 13.8228C75.0678 14.0649 75.3098 13.0215 74.5088 12.9464V12.938Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4659 17.6621C73.4659 18.2047 73.0654 18.6387 72.5648 18.6387C72.0643 18.6387 71.6638 18.1963 71.6638 17.6621C71.6638 17.1279 72.0643 16.6855 72.5648 16.6855C73.0654 16.6855 73.4659 17.1279 73.4659 17.6621Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.946 17.7119C77.946 18.2545 77.654 18.6885 77.2953 18.6885C76.9365 18.6885 76.6445 18.2461 76.6445 17.7119C76.6445 17.1777 76.9365 16.7354 77.2953 16.7354C77.654 16.7354 77.946 17.1777 77.946 17.7119Z",
    fill: "#231F20"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.359 57.3257C119.359 57.3257 106.245 54.7632 107.521 49.3211C108.798 43.879 112.961 44.8389 115.839 40.6822C118.717 36.5171 120.002 32.6776 123.197 32.0432C126.401 31.4005 136.312 37.8025 133.117 39.4051C129.913 41.0077 128.32 38.4452 128.637 42.6103C128.954 46.7753 126.718 50.932 126.718 50.932L128.32 51.8919C128.32 51.8919 134.718 47.4097 135.036 52.5346C135.353 57.6595 129.279 59.2538 127.36 56.6997C127.36 56.6997 123.197 58.9366 119.359 57.3424V57.3257Z",
    fill: "#FAD3D5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M121.278 81.0139C118.717 70.1631 98.3774 61.1903 84.1613 51.5664L73.5994 73.0177C73.5994 73.0177 103.033 97.0231 110.391 97.9829C117.749 98.9428 121.27 81.0139 121.27 81.0139H121.278Z",
    fill: "#2D307A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.56
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M105.919 85.8137C95.3239 84.7954 83.7024 74.3118 76.6528 66.8164L73.6077 73.0097C73.6077 73.0097 103.041 97.0151 110.399 97.975C115.563 98.6511 118.825 90.0455 120.319 84.8371C116.323 85.797 111.492 86.3479 105.919 85.8054V85.8137Z",
    fill: "#231F20"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M85.763 50.2809C84.8036 50.2809 80.0065 46.4414 80.0065 46.4414C80.0065 46.4414 67.8511 68.527 68.8105 68.8526C69.77 69.1697 73.933 74.6118 73.933 74.6118L85.7714 50.2809H85.763Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 248,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityOnboardingCat);
export default __webpack_public_path__ + "static/media/activity_onboarding_cat.cb15c2ff3935e5c5ddef8d0866135d5e.svg";
export { ForwardRef as ReactComponent };